
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "TOOIASTT",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TOOIASTT.vue